export class Node {
  vmId: string;
  depName: string;
  cloudType: string;
  instanceType: string;
  configId: string;
  actionTime: string;
  startTime: string;
  lastUpdate: string;
  hpcUnitsUsed: string;
  imageName: string;
  vmName: string;
  vmIp: string;
  nodeType: string;
  state: string;
  cores: string;
  totalRam: string;
  vmPlatform: string;
  billedHours: string;
  cpuUsage: string;
  ramUsage: string;
  description: string;
  isAllowedToConnect: boolean;
  autoScale: boolean;
  azureServiceName: string;
  availability: string | null;
  gpuName: string | null;
  gpuUsage: string | null;
  gpuMemoryUsage: string | null;
  gpuRamSize: string | null;
  sessions: string[] | [];
  identifierTag: string | null;
  isAllocated: boolean | null;
  processor: string | null;
  vmOs: string | 'NA';
  hostNodeId: string | null;
  reserved: boolean;
  mappedUsers: string[] | [];
  allDeploymentsList: string;
  connectorType: string;
  allocTotal: string;
  hostNodeVmId: string;
  schedulerState: string;
  slurmVmName: string;
  networkUsage: string;
  rdProtocol?: string;
  vmShutDownTime?: string;
  actionsAvl?: any;
}

export class VmInfo {
  public vmId: string;
  public instanceType: string;
  public publicIp: string;
  public privateIp: string;
  public bmcIp: string;
  public macAddress: string;
  public startCommand: string;
  public stopCommand: string;
  public restartCommand: string;
  public resetCommand: string;
  public rdProtocol?: string;
}


export class AddNode {
  constructor(
    public DeploymentName: string | null = null,
    public MachineName: string = null,
    public NodeType: string = null,
    public PlatformType: string | null = null,
    public AllowConnect: boolean | null = true,
    public MacAddress: string | null = null,
    public IpAddress: string | null = null,
    public PublicIP: string | null = null,
    public GatewayName: string | null = null,
    public SkipCloudDeployment: boolean = true,
    public NewMachineName: string | null = null,
    public NewMacAddress: string | null = null,
    public NewIpAddress: string | null = null,
    public NewPublicIP: string | null = null,
    public NewGatewayName: string | null = null,
    public ConnectorType: string | null = null,
    public OsDiskType: string | null = null,
    public Image: string | null = null,
    public NodeSize: string | null = null,
    public HostId: string | null = null,
    public StorageDomain: string | null = null,
    public ImageId: string | null = null,
    public StorageDomainId: string | null = null,
    public ProvisionSource: string | null = null,
    public NumberOfNodes: number | -1 = -1
  ) {}
}

export class GpuNodeList {
  gpuDeviceCount: number;
  gpuDeviceName: string;
}

export class HpcConfigs {
  HpcConfigId: number;
  CloudProvider: string;
  InstanceCode: number;
  NumOfSockets: number;
  CoresPerSocket: number;
  ThreadsPerCore: number;
  CpuCores: number;
  CpuType: string;
  NoOfGPU: number;
  gpuModel: string;
  gpuMemorySize: number;
  RamSize: string;
  HddSize: string;
  HddType: string;
  Description: string;
  maxHpcNodes: string;
  pricePerHour: string;
  IsRdmaSupported: string;
}

export class NewNodeConfig {
  NoOfGPU: number;
  gpuMemorySize: number;
  gpuModel: string;
  CpuCores: string;
  CpuType: string;
  CloudProvider: string;
  RamSize: string;
  HddSize: string;
  HddType: string;
  IsRdmaSupported: boolean;
  NumOfSockets: number;
  CoresPerSocket: number;
  ThreadsPerCore: number;
  Description: string;
}

export interface HeadNodeInfo {
  VmName: string;
  VmIp: string;
  VmType: string;
}

export interface NodeAction {
  name: string;
  value: number;
  title: string;
  icon: string;
  disabled: boolean;
}

export class AddWorkstationDTO {
  constructor(
    public MachineName: string = '',
    public IpAddress: string = '',
    public MacAddress: string = '',
    public GatewayName: string = '',
    public PlatformType: string = '',
    public ConnectorType: string = ''
  ) {}
}

/////////////////////\\\\\\\\\\\\\\\\\\\\\
export interface MultiNodeActionDTO {
  attachObj: AttachNodeAction | null;
  detachObj: DetachNodeAction[] | null;
}
export interface AttachNodeAction {
  deploymentNames: string;
  wsNames: string;
}
export interface DetachNodeAction {
  wsName: string;
  deploymentName: string;
}
//////////////////////\\\\\\\\\\\\\\\\\\\\

export interface NodeDescription {
  name: string;
  deploymentName: string;
  description: string;
}

export class AddVmPool {
  constructor(
    public PoolName: string,
    public DeploymentName: string,
    public NumberOfNodes: number,
    public TemplateName: string,
  ) { }
}

export class TemplatesList {
  templateId: string;
  templateName: string;
}

export class AllDisksAvailableForHost {
  name: string;
  id: string;
  contentType: string;
  format: string;
  storageType: string;
}

export class StorageDomains {
  name: string;
  id: string;
  type: string;
}
